import * as React from "react";
import PropTypes from "prop-types";

import Button from "ui/Button";

import SaveIcon from "assets/svg/save.svg";
import { AppThemeGradientContext } from "contexts/appCustomization/AppThemeGradientContext";

const Actions = ({ loading }) => {
  const { values } = React.useContext(AppThemeGradientContext);
  const isSaveBlocked = !values.dark.length || !values.light.length;

  return (
    <div className="theme-builder-theme-footer">
      <Button
        id="create-theme-submit"
        loading={loading}
        type="submit"
        color="primary"
        startIcon={<SaveIcon width="20px" height="20px" />}
        disabled={isSaveBlocked}
      >
        Save
      </Button>
    </div>
  );
};

Actions.propTypes = {
  loading: PropTypes.bool,
};

export default Actions;
